import moment from 'moment';

export default function calculMonthsBetweenTwoDate(dateDepart, dateFin) {
  if (moment(dateDepart).subtract(1, 'd').date() !== moment(dateFin).date()) return 0;
  const nbMois = moment.duration(moment(dateFin).diff(moment(dateDepart))).asMonths().toFixed(0);
  if (!Number.isNaN(nbMois)) return nbMois;
  return 0;
}
